import { useThemeContext } from "@circle-react/providers/Theme";
import { memo } from "react";

export const HighlightStylesByAppearance = memo(() => {
  const { isDarkAppearance } = useThemeContext();

  const stylesheet = isDarkAppearance
    ? {
        href: "https://cdnjs.cloudflare.com/ajax/libs/highlight.js/11.9.0/styles/github-dark.min.css",
        integrity:
          "sha512-rO+olRTkcf304DQBxSWxln8JXCzTHlKnIdnMUwYvQa9/Jd4cQaNkItIUj6Z4nvW1dqK0SKXLbn9h4KwZTNtAyw==",
      }
    : {
        href: "https://cdnjs.cloudflare.com/ajax/libs/highlight.js/11.9.0/styles/github.min.css",
        integrity:
          "sha512-0aPQyyeZrWj9sCA46UlmWgKOP0mUipLQ6OZXu8l4IcAmD2u31EPEy9VcIMvl7SoAaKe8bLXZhYoMaE/in+gcgA==",
      };

  return (
    <link
      rel="stylesheet"
      {...stylesheet}
      crossOrigin="anonymous"
      referrerPolicy="no-referrer"
    />
  );
});

HighlightStylesByAppearance.displayName = "HighlightStylesByAppearance";
